import { useEffect } from 'react'
import get from 'lodash/get'
import last from 'lodash/last'
import lozad from 'lozad'

import './style.scss'

const observer = lozad()

const PostYoutube = ({ post }) => {
  if (get(post, 'post_type') !== 'youtube') {
    return null
  }

  const extractYoutubeId = (url) => {
    if (!url) return null

    const regex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i
    const match = url.match(regex)

    return match ? match[1] : null
  }

  const youtubeId = extractYoutubeId(get(post, 'shared_url.url', ''))

  if (!youtubeId) {
    return null
  }

  useEffect(() => {
    observer.observe()
  }, [youtubeId])

  return (
    <div className="PostYoutube">
      <iframe
        className="lozad"
        width="100%"
        height={320}
        data-src={`https://www.youtube.com/embed/${youtubeId}`}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
    </div>
  )
}

export default PostYoutube
